// Main exports for the bridge module
export { BridgeApi } from './BridgeApi';
export type { BridgeApiConstructorType, NativeScreen } from './BridgeApi';

// Type exports
export type {
  BridgeCallback,
  BridgeMessage,
  BridgeRequest,
  FeatureFlags,
  FromNativeActionName,
  FromNativeActions,
  FromWebActionName,
  FromWebActions,
  OpenUrl,
  SendMessageToNative,
  SendMessageToWeb,
  BridgeHandler,
  BridgeHandlers,
} from './types';

// Utility function exports
export { buildBridgeMessage, buildNativeMessage } from './types';

// Utility exports
export { getBase64Image, isValidImageUri, createWebBridgeApi } from './utils';

// Event bridge for host → app custom events (e.g., WordPress → React)
export { WpBridge, wpBridge, WP_EVENT_CHANNEL } from './WpBridge';
